import { IClaioImageSource } from "../../../../../domain/claio";
export class ClaioImageReference {
  constructor(
    public text: string,
    public imageDate: Date,
    public imageKind: string,
    public departmentId: string,
    public areEqual: (source: IClaioImageSource, destination: ClaioImageReference) => boolean) {
  }

  clone() {
    return new ClaioImageReference(
      this.text,
      this.imageDate,
      this.imageKind,
      this.departmentId,
      this.areEqual
    );
  }
}
